import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AutoCompleteDropDown } from '../../models/autoComplete';
@Component({
  selector: 'app-auto-complete',
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.css']
})
export class AutoCompleteComponent implements OnInit, OnChanges {
  @Input() selectProperties: AutoCompleteDropDown;
  @Output() selectionChange = new EventEmitter<any>();
  @Output() propValueEvent = new EventEmitter<any>();
  keyUp = false;
  filterList = [];
  valueee: any;
  limit = 25;
  offset = 0;
  @ViewChild('auto', null) autoCmpt: any;
  panel: HTMLElement;

  constructor() {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.valueee = this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName].value;
      // this.setItems('');
      this.filterOptions('');
      // if (this.valueee) {
      setTimeout(() => {
        this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName].setValue(this.valueee);
        if (this.selectProperties.disabled ||
          this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName].disabled) {
          this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName].disable();
        } else {
          this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName].enable();
        }
      }, 0);
      // }
    }
  }
  ngOnInit() {
    if (this.selectProperties.items) {
      // this.setItems('');
      this.filterOptions('');
      if (this.selectProperties.disabled) {
        this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName].disable();
      } else {
        this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName].enable();
      }
    }
    this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName].valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(() => {
      this.offset = 0; // Reset offset when searching
      this.filterOptions(this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName].value);
    });
  }
  filterOptions(searchTerm) {
    if (searchTerm != '' && searchTerm != null) {
      const inputValue = searchTerm.toLowerCase().trim();
      this.filterList = this.selectProperties.items.filter((option) => option['name'].toLowerCase().includes(inputValue)).slice(0, this.offset + this.limit);
    } else {
      if(this.selectProperties && this.selectProperties.items && this.selectProperties.items.length >0 )
      {
        this.filterList = this.selectProperties.items.slice(0, this.offset + this.limit);
      }     
    }
  }
  onScroll() {
    this.panel = this.autoCmpt.panel.nativeElement;
    if (this.panel) {
      const threshold = 200; // Adjust the threshold as needed
      const scrollPosition = this.panel.scrollTop + this.panel.clientHeight;
      const maxScroll = this.panel.scrollHeight;
      if (maxScroll - scrollPosition < threshold) {
        // Check if the current filteredOptions length is equal to the current offset
        // if (this.filteredOptions.length === this.offset) {
        this.offset += this.limit;
        this.filterOptions('');
        // }
      }
    }
  }
  keyUpFunction(event, value) {
    if (event.key === 'Enter' || event.key === 'Tab') {
      event.preventDefault();
      return false;
    } else {
      if (value) {
        this.propValueEvent.emit({
          propertyName: this.selectProperties.formControlName,
          // tslint:disable-next-line: object-literal-shorthand
          value: value
        });
        const data = this.filterList.filter(e =>
          e[this.selectProperties.controlName].toLowerCase() === value.toLowerCase());
        if (data.length > 0) {
          this.keyUp = true;
        } else {
          this.keyUp = true;
        }
      } else {
        this.propValueEvent.emit({
          propertyName: this.selectProperties.formControlName,
          // tslint:disable-next-line: object-literal-shorthand
          value: value
        });
        this.keyUp = false;
      }
    }
  }
  get displayDataFn() {
    const dataNew = (data) => {
      if (data == null || data === undefined || data === '') {
        return null;
      } else {
        if (this.filterList && this.filterList.length > 0) {
          data = this.selectProperties.items.find(x => x[this.selectProperties.controlId] === data);
          if (data) {
            return data[this.selectProperties.controlName];
          } else {
            return null;
          }
        } else {
          return null;
        }
      }
    };
    return dataNew;
  }

  // Resource ..
  setItems(value) {
    if (!value) { this.assignResourceCopy(); }
    if (value) {
      this.filterList = Object.assign([], this.selectProperties.items).filter(
        item => ((item[this.selectProperties.controlName].toLowerCase().indexOf(value.toLowerCase()) > -1)));
    }
    // this.assignResourceCopy();
  }
  assignResourceCopy() {
    this.filterList = Object.assign([], this.selectProperties.items);
  }

  checkValidValue() {
    const value = this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName].value;
    if (value === '' || value == null) {
    } else if (this.keyUp) {
      this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName].setValue('');
      this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName].setErrors({ incorrect: true });
    } else {
      this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName].setErrors(null);
    }
  }

  checVal(value) {
    if (this.selectProperties.showDefaultSelect === false) {
      const data: any = this.selectProperties.items.filter(e => e[this.selectProperties.controlName].toLowerCase().trim() ===
        value.toLowerCase().trim());
      if (data.length > 0) {
        const datax = data[0];
        this.selectProperties.selectFormGroup.controls[this.selectProperties.formControlName]
          .setValue(datax[this.selectProperties.controlId]);
        this.keyUp = false;
      }
      this.checkValidValue();
    }
  }
  getId(event) {
    this.selectionChange.emit(event.option.value);
    this.propValueEvent.emit({
      propertyName: this.selectProperties.formControlName,
      value: event.option.value
    });
  }
}
